/** Who may draft a statement: the server's `MAY_WRITE`. A Viewer or an Auditor reads the pack and is
 * not shown a control that predictably 403s (design rule 6). */
export const MAY_DRAFT: ReadonlySet<string> = new Set(["admin", "approver", "contributor"]);
